export const regType = {
  temperature: 0,
  time: 1,
  duration: 2,
  other: 3,
  name: 4,
  off_on: 5,
  dis_en: 6,
  pump_speed: 7,
  lookup: 8,
  start_stop_time: 9,
};

export const RT = {
  Input: 0,
  Holding: 1,
  not_used: 2,
};
